/** FAQ, Support, and Advertising page copy (Turkish translation). */
export const pagesMessagesTr = {
  faq: {
    pageTitle: "Sıkça Sorulan Sorular",
    pageSubtitle: "WasOK hakkındaki sık sorulan sorulara yanıt bulun",
    seoTitle: "SSS — WasOK",
    seoDescription:
      "WasOK, ürün tarama, gizlilik ve puanlar hakkında sık sorulan soruların yanıtları.",
    items: [
      {
        question: "WasOK nasıl çalışır?",
        answer:
          "WasOK, barkodları tarayarak ve puanlarınızla notlarınızı kaydederek hangi ürünleri beğenip beğenmediğinizi hatırlamanıza yardımcı olur. Bir ürünün barkodunu tarayın, puanlayın, not ekleyin; aynı ürünü bir dahaki sefere taradığınızda önceki değerlendirmenizi anında görürsünüz.",
      },
      {
        question: "Verilerim bulutta mı saklanıyor?",
        answer:
          "Hayır! Tüm verileriniz cihazınızda yerel olarak saklanır. Bilgilerinizi buluta senkronize etmeyiz, bu da alışveriş geçmişinizin ve ürün görüşlerinizin tamamen özel kalması anlamına gelir. Ancak bu, verilerinizi korumak istiyorsanız cihazınızı yedeklemeniz gerektiği anlamına da gelir.",
      },
      {
        question: "WasOK'u kullanmak için internet bağlantısı gerekli mi?",
        answer:
          "Hayır, WasOK tamamen çevrimdışı çalışır. Tüm verileriniz cihazınızda yerel olarak saklandığından, herhangi bir internet bağlantısı olmadan ürün tarayabilir, puan ekleyebilir ve geçmişinizi görüntüleyebilirsiniz.",
      },
      {
        question: "WasOK'u her tür ürün için kullanabilir miyim?",
        answer:
          "Evet! WasOK, barkodu olan her ürünle çalışır. Gıda, kozmetik, ev eşyaları, elektronik veya barkodu olan başka bir şey olsun, tarayabilir ve görüşlerinizi kaydedebilirsiniz.",
      },
      {
        question: "Barkodu nasıl tararım?",
        answer:
          "WasOK uygulamasını açın ve tarama düğmesine dokunun. Kameranızı ürünün barkoduna doğrultun, uygulama otomatik olarak algılayıp tarayacaktır. En iyi sonuç için barkodun iyi aydınlatılmış ve net olduğundan emin olun.",
      },
      {
        question: "Ürün değerlendirmelerime fotoğraf ekleyebilir miyim?",
        answer:
          "Evet! Herhangi bir ürün değerlendirmesine fotoğraf ekleyebilirsiniz. Bu, ambalaj detaylarını, içerik listelerini veya bir ürünü neden beğenip beğenmediğinizi hatırlamanıza yardımcı olacak diğer görsel bilgileri hatırlamak için özellikle faydalıdır.",
      },
      {
        question: "Ürünler hakkında hangi bilgileri kaydedebilirim?",
        answer:
          "Puanları (1-5 yıldız), metin notlarını, fotoğrafları, ödediğiniz fiyatı, nereden aldığınızı ve özel kategorileri kaydedebilirsiniz. Bu kapsamlı bilgi, alışveriş yaparken bilinçli kararlar vermenize yardımcı olur.",
      },
      {
        question: "Alışveriş listeleri oluşturabilir miyim?",
        answer:
          "Evet! WasOK, daha önce değerlendirdiğiniz ürünlerden alışveriş listeleri oluşturmanıza olanak tanır. Bu, hangi ürünleri sevdiğinizi ve tekrar satın almak istediğinizi hatırlamayı kolaylaştırır.",
      },
      {
        question: "Ürünlerimi nasıl düzenlerim?",
        answer:
          "Ürünleri özel kategoriler kullanarak düzenleyebilirsiniz. Örneğin, 'Atıştırmalıklar', 'Kahve', 'Cilt Bakımı' veya 'Temizlik Ürünleri' gibi kategoriler oluşturabilirsiniz. Bu, değerlendirmelerinizi türe göre gözden geçirmeyi kolaylaştırır.",
      },
      {
        question: "WasOK kullanımı ücretsiz mi?",
        answer:
          "Evet, WasOK indirmek ve kullanmak tamamen ücretsizdir. Uygulama içi satın alma, abonelik veya gizli ücret yoktur. Herkesin ürün tercihlerini hatırlamanın özel bir yoluna erişimi olması gerektiğine inanıyoruz.",
      },
      {
        question: "WasOK erişilebilir mi?",
        answer:
          "WasOK, mümkün olduğunca çok kişi tarafından kullanılabilir olacak şekilde tasarlanmıştır. Uygulama, ekran okuyucu desteği, ölçeklenebilir metin ve isteğe bağlı yüksek kontrast modu gibi erişilebilirlik özellikleri içerir.",
      },
      {
        question: "Uygulamayı kaldırırsam ne olur?",
        answer:
          "Tüm veriler cihazınızda yerel olarak saklandığından, uygulamayı kaldırmak tüm ürün değerlendirmelerinizi, notlarınızı ve alışveriş listelerinizi siler. Kaldırmadan önce yedek almak istiyorsanız verilerinizi dışa aktardığınızdan emin olun.",
      },
      {
        question: "Verilerimi dışa aktarabilir miyim?",
        answer:
          "Evet, WasOK yedekleme amacıyla verilerinizi dışa aktarmanıza olanak tanır. Tüm değerlendirmelerinizi cihazınıza veya tercih ettiğiniz bulut depolamaya kaydedebileceğiniz bir dosyaya aktarabilirsiniz.",
      },
      {
        question: "WasOK konumumu takip ediyor mu?",
        answer:
          "Hayır, WasOK konumunuzu takip etmez. Bir ürünü satın aldığınız mağazanın adını manuel olarak girebilseniz de, uygulama GPS veya konum hizmetlerini kullanmaz.",
      },
      {
        question: "WasOK'u birden fazla cihazda kullanabilir miyim?",
        answer:
          "Şu anda, tüm veriler yerel olarak saklandığından WasOK cihazlar arasında senkronize olmaz. Her cihazın kendine ait ayrı bir ürün ve değerlendirme veritabanı olacaktır.",
      },
      {
        question: "Bir barkod taranmazsa ne olur?",
        answer:
          "Bir barkod taranmıyorsa, iyi aydınlatıldığından ve net olduğundan emin olun. Kamera lensini temizlemeyi de deneyebilirsiniz. Barkod hasarlı veya belirsizse, barkod numarasını manuel olarak girebilirsiniz.",
      },
    ],
    cta: {
      heading: "Hâlâ sorularınız mı var?",
      body: "Destek ekibimizle iletişime geçin — size yardımcı olmaktan mutluluk duyarız.",
      button: "Destekle iletişime geç",
    },
  },
  support: {
    pageTitle: "Destek",
    seoTitle: "Destek — WasOK",
    seoDescription:
      "WasOK ile ilgili yardım alın: destekle iletişime geçin, hataları bildirin ve geri bildirim paylaşın.",
    getHelp: {
      title: "Yardım Alın",
      body: "WasOK'tan en iyi şekilde yararlanmanız için buradayız. Sorun yaşıyorsanız veya sorularınız varsa, size yardımcı olacak birkaç kaynağımız var.",
    },
    faq: {
      title: "Sıkça Sorulan Sorular",
      body: "Bize ulaşmadan önce, WasOK hakkındaki en sık sorulan soruları yanıtladığımız SSS bölümümüze göz atın. Uygulamanın nasıl çalıştığı, gizlilik, veri depolama ve daha fazlası hakkında ayrıntılı bilgi bulacaksınız.",
    },
    contact: {
      title: "Destekle İletişime Geçin",
      body: "Aradığınız yanıtı bulamıyorsanız, destek ekibimiz yardımcı olmaya hazır. Bize şu adresten ulaşabilirsiniz:",
      emailLabel: "E-posta:",
      responseTime: "Genellikle 24-48 saat içinde yanıt veriyoruz",
    },
    bugs: {
      title: "Hata Bildirme",
      body: "Bir hata mı buldunuz? WasOK'u daha iyi hale getirmemize yardımcı olduğunuz için teşekkür ederiz. Bir hata bildirirken lütfen şunları ekleyin:",
      items: [
        "Sorunun ayrıntılı bir açıklaması",
        "Sorunu yeniden oluşturma adımları",
        "Cihaz modeliniz ve Android sürümünüz",
        "Mümkünse ekran görüntüleri veya ekran kayıtları",
      ],
      sendPrefix: "Hata raporlarını şu adrese gönderin:",
    },
    featureRequests: {
      title: "Özellik Talepleri",
      bodyBefore: "Yeni bir özellik fikriniz mi var? Sizden haber almayı çok isteriz! Önerilerinizi şu adrese gönderin:",
      bodyAfter:
        ". Her talebi uygulayamasak da, gelecekteki güncellemeleri planlarken tüm geri bildirimleri dikkatle değerlendiriyoruz.",
    },
    knownIssues: {
      title: "Bilinen Sorunlar",
      body: "Şu anda aşağıdaki sorunların farkındayız ve çözümleri üzerinde çalışıyoruz:",
      items: [
        "Bazı barkodlar düşük ışıkta taranmayabilir — bir el feneri kullanmayı deneyin",
        "Çok uzun ürün notlarının kaydedilmesi eski cihazlarda biraz zaman alabilir",
        "Görüntü küçük resimleri yüksek çözünürlüklü ekranlarda pikselli görünebilir",
      ],
    },
    appUpdates: {
      title: "Uygulama Güncellemeleri",
      body: "Yeni özellikler, iyileştirmeler ve hata düzeltmeleri içeren güncellemeleri düzenli olarak yayınlıyoruz. En son geliştirmeleri almak için WasOK'u Google Play Store üzerinden güncel tuttuğunuzdan emin olun.",
    },
    community: {
      title: "Topluluk",
      body: "WasOK ile daha akıllı alışveriş kararları veren kullanıcı topluluğumuza katılın. İpuçlarını paylaşın, sorular sorun ve sosyal kanallarımızda diğer kullanıcılarla bağlantı kurun.",
    },
    emergency: {
      title: "Acil Destek",
      body: 'Uygulamayı kullanmanızı engelleyen kritik bir sorun yaşıyorsanız, lütfen konu satırında e-postanızı "ACİL" olarak işaretleyin, talebinize öncelik vereceğiz.',
    },
    cta: {
      heading: "Hâlâ yardıma mı ihtiyacınız var?",
      body: "Destek ekibimiz sizin için burada. Herhangi bir soru veya endişeyle bize ulaşmaktan çekinmeyin.",
      button: "Destek E-postası Gönder",
    },
  },
  advertising: {
    pageTitle: "Reklamcılık ve Gelir Modeli",
    seoTitle: "Reklamcılık — WasOK",
    seoDescription: "WasOK'un reklamcılık ve gelir modeline yaklaşımı.",
    approach: {
      title: "Yaklaşımımız",
      body: "WasOK'ta, alışveriş alışkanlıklarınızın ve ürün görüşlerinizin özel ve kişisel olduğuna inanıyoruz. İş modelimiz bu temel değeri yansıtır.",
    },
    noAds: {
      title: "Reklam Yok",
      body: "WasOK herhangi bir reklam göstermez. Taradığınız ürünlere, verdiğiniz puanlara veya uygulamada oluşturduğunuz başka herhangi bir veriye dayalı olarak size asla reklam göstermeyeceğiz. WasOK deneyiminiz tamamen reklamsızdır.",
    },
    noDataSelling: {
      title: "Veri Satışı Yok",
      body: "Verilerinizi reklamverenlere, veri komisyoncularına veya herhangi bir üçüncü tarafa satmıyor, kiralamıyor veya paylaşmıyoruz. Tüm verileriniz cihazınızda yerel olarak saklandığından, biz bile bunlara erişemiyoruz. Ürün değerlendirmeleriniz, alışveriş listeleriniz ve notlarınız yalnızca size aittir.",
    },
    noTracking: {
      title: "Takip Yok",
      body: "WasOK, davranışlarınızı izleyen veya üçüncü taraflarla bilgi paylaşan takip pikselleri, analitik hizmetleri veya başka herhangi bir teknoloji kullanmaz. Hangi ürünleri taradığınızı, hangi mağazalardan alışveriş yaptığınızı veya uygulamayı nasıl kullandığınızı takip etmiyoruz.",
    },
    sustainability: {
      title: "Nasıl Sürdürülebilir Kalıyoruz",
      body: "Reklam veya veri satışı olmadan WasOK'u nasıl ücretsiz tuttuğumuzu merak ediyor olabilirsiniz. Yaklaşımımız basit:",
      items: [
        {
          label: "Ücretsiz ve Açık:",
          text: "WasOK, premium katman veya ücretli duvar olmadan herkes için ücretsizdir",
        },
        {
          label: "Yalın İşletme:",
          text: "Verimli, gizlilik odaklı yazılımlar geliştirerek maliyetlerimizi düşük tutuyoruz",
        },
        {
          label: "İsteğe Bağlı Bağışlar:",
          text: "WasOK'u seven kullanıcılar gönüllü bağışlarla bizi destekleyebilir",
        },
        {
          label: "Açık Kaynak:",
          text: "Kuruluşlar için danışmanlık veya özel geliştirme hizmetleri sunabiliriz",
        },
      ],
    },
    noAffiliate: {
      title: "Ortaklık Bağlantısı Yok",
      body: "WasOK, satıcılardan ortaklık bağlantısı kullanmaz veya komisyon almaz. Bir ürünü taradığınızda, sizi satın almak için herhangi bir yere yönlendirmeyiz. Uygulama yalnızca kişisel kayıt tutma ve karar verme amaçlıdır.",
    },
    noPromotions: {
      title: "Ürün Tanıtımı Yok",
      body: "Markalardan veya üreticilerden ürünlerini tanıtmak için ödeme almıyoruz. WasOK asla ürün önermez, belirli markaları öne çıkarmaz veya puanlarınızı hiçbir şekilde etkilemez. Görüşleriniz size aittir.",
    },
    partnerships: {
      title: "Üçüncü Taraf Ortaklıkları",
      body: "WasOK, pazarlama şirketleri, veri toplayıcılar veya reklam ağlarıyla ortaklık kurmaz. Bağımsız çalışıyor ve her şeyden önce gizliliğinize öncelik veriyoruz.",
    },
    future: {
      title: "Gelecek Planları",
      body: "WasOK'u reklamsız ve gizlilik odaklı tutmaya kararlıyız. Gelecekte sürdürülebilir bir iş modeli sunmamız gerekirse, şunları yapacağız:",
      items: [
        "Herhangi bir değişikliği önceden duyuracağız",
        "Gizlilik veya veri güvenliğinden asla ödün vermeyeceğiz",
        "Uygulamayı takip veya reklam olmadan kullanmak için her zaman bir yol sunacağız",
        "Kullanıcı geri bildirimlerini ve endişelerini dinleyeceğiz",
      ],
    },
    supporting: {
      title: "WasOK'u Destekleme",
      body: "WasOK'u seviyor ve gizlilik odaklı alışveriş hafızası misyonumuzu desteklemek istiyorsanız şunları yapabilirsiniz:",
      items: [
        "Arkadaşlarınıza ve ailenize uygulamadan bahsedin",
        "Google Play Store'da olumlu bir değerlendirme bırakın",
        "Geri bildirim ve önerilerinizi bizimle paylaşın",
        "Gönüllü bir bağış yapmayı düşünün (mevcut olduğunda)",
      ],
    },
    cta: {
      heading: "Politikalarımız hakkında sorularınız mı var?",
      body: "WasOK'un nasıl çalıştığı konusunda şeffafız. Gizlilik, gelir modeli veya sürdürülebilirlik yaklaşımımızla ilgili herhangi bir sorunuz varsa, lütfen bizimle iletişime geçin.",
      button: "Bize Ulaşın",
    },
  },
};
